import React from "react";
import Weather from "./Weather";

import "./App.css";

export default function App() {
  return (
    <body className="App">
      <Weather defaultCity="Barcelona" />
    </body>
  );
}
